export default "__VITE_ASSET__2ZCqq_IxPuC3uZYm3g37uA__"